import { useState, useEffect } from 'react';

interface UseBusinessCreationFlowProps {
  isLoading: boolean;
  onComplete: () => void;
}

export const useBusinessCreationFlow = ({ isLoading, onComplete }: UseBusinessCreationFlowProps) => {
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  useEffect(() => {
    if (isButtonClicked && !isLoading) {
      onComplete();
      setIsButtonClicked(false);
    }
  }, [isButtonClicked, isLoading, onComplete]);

  const handleButtonClick = () => {
    setIsButtonClicked(true);
  };

  const showLoading = isButtonClicked || isLoading;

  return {
    showLoading,
    handleButtonClick,
  };
};
